import styled, { css } from 'styled-components';

type ContainerProps = {
  expired?: boolean;
};

export const Container = styled.li<ContainerProps>`
  max-width: 48.5rem;
  min-height: 30rem;
  background: #ffffff;
  border-radius: 4px;
  cursor: pointer;

  padding: 2.6rem 3.5rem;

  div {
    width: 100%;
    font-size: 21px;
    padding-bottom: 1rem;

    span {
      color: green;

      ${(props) =>
        props.expired &&
        css`
          color: red;
        `}
    }
  }
`;
